import TransitionsMantis from 'mantis/components/@extended/Transitions';

const Transitions = (props) => {
	return <TransitionsMantis {...props} />;
};

export default Transitions;
